<template>
  <div
    id="cases"
    class="cases-content"
  >
    <title-bar
      class="title-bar"
      title-light="案列"
      title="展示"
      desc="为您详细展示调查过程、服务方式、调查结果"
    ></title-bar>
    <case-item
      v-for="item in cases"
      :key="item.title"
      :title="item.title"
      :item="item.item"
      :server="item.server"
      :survey="item.survey"
      :into="item.into"
      :effect="item.effect"
      :image="item.img"
    ></case-item>
    <div class="more"><button
        class="more-btn"
        @click="handleToCases"
      >查看更多</button></div>
  </div>
</template>

<script>
import TitleBar from '@/components/TitleBar'
import CaseItem from './components/CaseItem'

import CaseImgOne from '@/assets/images/cases/1-2.jpg'
import CaseImgTwo from '@/assets/images/cases/2-1.jpg'

export default {
  name: 'CasesContent',
  data () {
    return {
      cases: [{
        img: CaseImgOne,
        title: '典型案列（一）',
        item: '鹿城区七都街道、瓯海区南白象、娄桥及郭溪街道第四次经济普查',
        server: '入户调查',
        survey: '32000家',
        into: '配备普查指导员30名，其中4名负责派驻街道办事处进行业务管理。先后调动620名兼职调查员参与入户调查、数据录入及审核修改，协调村级网格人员260多名。',
        effect: '1、开发铃铃助手、经普助手等系统平台，并借助其技术手段领先高质量完成划区绘图、清查摸底及入户登记工作,得到当地领导的高度评价。'
      }, {
        img: CaseImgTwo,
        title: '典型案列（二）',
        item: '温州市瓯海区人才资源统计工作服务',
        server: '电话调查',
        survey: '6000家',
        into: '配备云呼系统5台、电话座机5台，电话催报员10人，表单收集技术支持5人，数据汇总处理3人。',
        effect: '1、公司技术团队开发表单在线填报系统，填报指标及填报要求以短信链的接形式通过平台直接发送到统计对象手机，利用技术手段将数据预报、指标解释及数据上报流程重新整合优化，大大提高了统计效率和数据质量。'
      }]
    }
  },
  methods: {
    handleToCases () {
      this.$router.push('/cases')
    }
  },
  components: {
    TitleBar,
    CaseItem
  }
}
</script>

<style lang="less" scoped>
.cases-content {
  .title-bar {
    padding: 60px 0;
  }
  .case-item ~ .case-item {
    margin-top: 60px;
  }
  .more {
    margin-top: 50px;
    text-align: center;
    &-btn {
      width: 160px;
      padding: 17px 0;
      border: none;
      border-radius: 100px;
      box-shadow: none;
      outline: none;
      font-size: 16px;
      color: #fff;
      background-color: #2e62e2;
      transition: 0.2s;
      cursor: pointer;
      &:hover {
        background-color: #4371e5;
      }
      &:active {
        background-color: #1d52d7;
      }
    }
  }
}
</style>
